import { Injectable } from '@angular/core';
import { Dexie, Table } from 'dexie';

export interface IPreferences {
  language: string;
}

@Injectable({
  providedIn: 'root',
})
export class DexieIndexedDBService extends Dexie {
  preferences!: Table<IPreferences, number>; // Generic table for using

  constructor() {
    super('AIFlowCRM');
    this.version(1).stores({
      preferences: '++id,language',
      // todoItems: '++id,todoListId,title,done',
    });

    // this.on('populate', () => this.populate());
  }

  // async populate() {
  //   const todoListId = await this.todoLists.add({
  //     title: 'To Do Today',
  //   });
  //   await this.todoItems.bulkAdd([
  //     {
  //       todoListId,
  //       title: 'Feed the birds',
  //     },
  //     {
  //       todoListId,
  //       title: 'Watch a movie',
  //     },
  //     {
  //       todoListId,
  //       title: 'Have some sleep',
  //     },
  //   ]);
  // }
}

// export const dexieDBService = new DexieIndexedDBService();
